import React, { useEffect } from "react";
import { Container, } from "react-bootstrap";
import { connect } from "react-redux";
import MaterialTable from "material-table";
import { baseURL, headers } from "../../../../../global/api";
import { deleteProduct, updateProduct, getAllProductPDFApi, updateProductStatusApi } from "./Product.action";
import { setHeading } from "../../../accounts/account.actions";
// import _ from 'lodash'
import { PDFHeader } from "../../../../../global/globalFunctions";
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import BlockIcon from '@mui/icons-material/Block';
import Button from '@mui/material/Button';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
const tableRef = React.createRef()


const ViewProduct = (props) => {
  const permissions = JSON.parse(window.localStorage.getItem("permissions"))
  const Checkpermissions = (permissionsType, permissionsName) => {
    return permissions.some(p => p[`${permissionsType}`] === permissionsName) ? false : true
  }

  const exportPDF = () => {
    props.getAllProductPDFApi();
  };

  useEffect(() => {
    props.setHeading("Product Details");
  }, []);

  return (
    <>
      <Container fluid>
        <Button style={{ marginBottom: '30px', textTransform: 'none', fontSize: '17px' }} variant="contained" endIcon={<SimCardDownloadIcon />} size="large" onClick={() => exportPDF()}> Download Product Report </Button>
        <MaterialTable
          tableRef={tableRef}
          title="Product Details"
          columns={[
            // { title: 'Image', field: 'images', editable: 'never', render: rowData => <img src={`${baseURL}/assets/${rowData.images}`} alt="img" style={{ width: 50, borderRadius: '50%' }} /> },
            { title: 'S.No', field: 'sequenceNumber', editable: 'never' },
            // { title: 'Code', field: 'code' },
            { title: "Company", field: "retaurantId.restaurantName", editable: 'never' },
            // { title: "Business Location", field: "wareHouseId.businessName", editable: 'never' },
            { title: "Category", field: "category.name", editable: 'never' },
            // { title: "Sub-Category", field: "subCategoryId.subCategoryName", editable: 'never' },
            {
              title: "Product Name", field: "name",
              render: (rowData) => (
                <div
                  style={{
                    backgroundColor: rowData.productTypeName === "Variation Product" ? "transparent" : Number(rowData.productBalance) <= Number(rowData.minimumBalance) ? "#ff8d8d" : Number(rowData.productBalance) >= Number(rowData.maximumBalance) ? "#addfac" : "transparent",
                    padding: "5px 16px 7px",
                    borderRadius: "10px",
                    textAlign: "center",
                    width: "max-content"
                  }}
                >
                  {rowData.name}
                </div>
              ),
            },
            // { title: "Product Discount", field: "discount" },
            // { title: "Opening Balance", field: "openingBalance", editable: 'never' },
            // { title: "Closing Balance", field: "productBalance", editable: 'never' },
            // { title: "Description", field: "desc" },
            // { title: "Type", field: "productTypeName", editable: 'never' },
            { title: "Purchase Price", field: "purchasePrice" },
            { title: "Sale Price", field: "salePrice" },
            // { title: "Barcode", field: "barcodeId" },
            // { title: "Product Red Color Time", field: "redColorTime" },
            // { title: "Product Yellow Color Time", field: "yellowColorTime" },
            // { title: "Product Green Color Time", field: "greenColorTime" },
            {
              title: "Status", field: "status", editable: 'never',
              render: rowData => (
                <div
                  style={{
                    backgroundColor: rowData.status ? "#addfac" : "#ff8d8d",
                    padding: "5px 16px 7px",
                    borderRadius: "10px",
                    textAlign: "center",
                    width: "max-content"
                  }}
                >
                  {rowData.status ? "Active" : "Blocked"}
                </div>
              )
            },
            // { title: "UOM", field: "uomLabel", editable: 'never' },
            { title: "Date", field: "productDate", editable: 'never' },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = `${baseURL}/products?allProducts=true`;
              url += "&limit=" + query.pageSize;
              url += "&page=" + (query.page);
              url += "&search=" + query.search;
              fetch(url, {
                method: 'GET',
                headers: headers,
              }).then((response) => response.json()).then((result) => {
                resolve({
                  data: result.data,
                  resImage: result.resImage,
                  page: result.page,
                  totalCount: result.total_results,
                });
              });
            })
          }
          detailPanel={rowData => {
            return (
              <MaterialTable
                columns={[
                  { title: 'Color', field: 'colourLabel' },
                  { title: 'Size', field: 'sizeLabel' },
                  { title: 'Product Balance', field: 'productBalance' },
                  { title: 'Sale Price', field: 'salePrice' },
                  { title: 'Purchase Price', field: 'purchasePrice' },
                ]}
                data={rowData.variation}
                options={{
                  actionsColumnIndex: -1,
                  toolbar: false,
                  exportButton: false,
                  sorting: false,
                  paging: false,
                  pageSize: 50,
                  emptyRowsWhenPaging: false,
                  pageSizeOptions: [50, 100, 150, 200],
                  headerStyle: {
                    position: 'sticky', top: 0,
                    color: '#00BBBB',
                    fontWeight: '550',
                    onRowAdd: 'none',
                  }
                }}
              />
            )
          }}
          options={{
            actionsColumnIndex: -1,
            exportButton: true,
            exportAllData: true,
            paging: true,
            pageSize: 50,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [50, 100, 150, 200],
            headerStyle: {
              position: "sticky",
              top: 0,
              color: "#00BBBB",
              fontWeight: "550",
              onRowAdd: "none",
            },
            exportPdf: (columns, data) => {
              const unit = "pt";
              const size = "A4";
              const orientation = "l";
              const doc = new jsPDF(orientation, unit, size);
              PDFHeader(doc, "Product Details");

              const columnDetails = [
                // { title: 'Code' },
                { title: "Company" },
                { title: "Business Location" },
                { title: "Category" },
                { title: "Sub-Category" },
                { title: "Name" },
                { title: "Purchase Price", },
                { title: "Sale Price" },
                { title: "Opening Balance" },
                { title: "Closing Balance" },
                { title: "Description" },
                { title: "Status" },
                { title: "Date" },
              ];
              const columnTitles = columnDetails.map(columnDef => columnDef.title);
              const pdfData = data.map((columnDef) => [
                // columnDef.code,
                columnDef.retaurantId.restaurantName,
                columnDef.wareHouseId.businessName,
                columnDef.category.name,
                columnDef.subCategoryId.subCategoryName,
                columnDef.name,
                columnDef.purchasePrice,
                columnDef.salePrice,
                columnDef.openingBalance,
                columnDef.productBalance,
                columnDef.desc,
                columnDef.status === true ? 'Active' : 'Blocked',
                columnDef.productDate,
              ]);
              let content = {
                startY: 120,
                startX: 5,
                head: [columnTitles],
                body: pdfData,
                headStyles: { fillColor: "#2980ba", font: 'Amiri', fontSize: 10 },
                styles: { fontSize: 9 },
                theme: "grid",
              };

              doc.setFontSize(11)
              doc.setFont("Times New Roman", "Normal")
              doc.autoTable(content);

              doc.setProperties({ title: 'Product Details' })
              doc.output('dataurlnewwindow')
            },
          }}
          editable={{
            isEditHidden: rowData => Checkpermissions("permissionsSubCatName", "Product Edit"),
            isDeleteHidden: rowData => Checkpermissions("permissionsSubCatName", "Product Delete"),
            onRowUpdate: (newData, oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.updateProduct(newData, oldData);
                }, 600);
              }),
            isDeletable: false,
            onRowDelete: (oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.deleteProduct(oldData._id);
                }, 600);
              }),
          }}
          actions={[
            {
              icon: 'refresh',
              tooltip: 'Refresh Data',
              isFreeAction: true,
              onClick: () => tableRef.current && tableRef.current.onQueryChange(),
            },
            (rowData) => ({
              disabled: rowData.status === false ? false : true,
              icon: () => <TaskAltIcon style={{ color: rowData.status === false ? 'green' : '#cccccc' }} />,
              tooltip: "Active Product",
              onClick: (event, rowData) => {
                const status = true
                props.updateProductStatusApi(status, rowData._id);
                tableRef.current && tableRef.current.onQueryChange();
              },
            }),
            (rowData) => ({
              disabled: rowData.status === true ? false : true,
              icon: () => <BlockIcon style={{ color: rowData.status === true ? '#dc3545' : '#cccccc' }} />,
              tooltip: "Block Product",
              onClick: (event, rowData) => {
                const status = false
                props.updateProductStatusApi(status, rowData._id);
                tableRef.current && tableRef.current.onQueryChange();
              },
            }),
          ]}
        />
      </Container>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    deleteProduct: (productId) => dispatch(deleteProduct(productId)),
    updateProduct: (newData, oldData) => dispatch(updateProduct(newData, oldData)),
    getAllProductPDFApi: (handleDangerVisible) => dispatch(getAllProductPDFApi(handleDangerVisible)),
    updateProductStatusApi: (newData, oldData) => dispatch(updateProductStatusApi(newData, oldData)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  productDataList: state.ProductReducer.productDataList,
  isFetchingProduct: state.ProductReducer.isFetchingProduct,
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewProduct);